export default {
    marcaEquipamentos: [],
    marcaEquipamento: {}
}